var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlucose(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 20,
    viewBox: "0 0 13 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 6.2963C0 2.81895 2.81895 0 6.2963 0C9.77364 0 12.5926 2.81895 12.5926 6.2963V16C12.5926 18.2091 10.8017 20 8.59259 20H4C1.79086 20 0 18.2091 0 16V6.2963Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740723 6.29628C0.740723 3.22803 3.22803 0.740723 6.29628 0.740723C9.36453 0.740723 11.8518 3.22803 11.8518 6.29628V15.2592C11.8518 17.4684 10.061 19.2592 7.85183 19.2592H4.74072C2.53158 19.2592 0.740723 17.4684 0.740723 15.2592V6.29628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48145 6.29626C1.48145 3.63711 3.63711 1.48145 6.29626 1.48145C8.95541 1.48145 11.1111 3.63711 11.1111 6.29626V8.66093C11.1111 10.4232 9.68247 11.8518 7.92019 11.8518H4.67233C2.91005 11.8518 1.48145 10.4232 1.48145 8.66093V6.29626Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.48145 16.9998C1.48145 15.6468 3.11731 14.9692 4.07404 15.9259C5.03077 16.8827 4.35317 18.5185 3.00015 18.5185C2.16139 18.5185 1.48145 17.8386 1.48145 16.9998Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.074 16.9998C11.074 15.6468 9.43811 14.9692 8.48138 15.9259C7.52465 16.8827 8.20225 18.5185 9.55527 18.5185C10.394 18.5185 11.074 17.8386 11.074 16.9998Z",
    fill: "#333333"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlucose);
export default __webpack_public_path__ + "static/media/glucose.ceb37bd52caa29335dd52faed341778a.svg";
export { ForwardRef as ReactComponent };